export default {
  gallonsUnitOfMeasureCode: 'gal',
  quartsUnitOfMeasureCode: 'qt',
  hoursUnitOfMeasureCode: 'h',
  milesUnitOfMeasureCode: 'm',
  percentUnitOfMeasureCode: 'pct',
  partsPerMillionUnitOfMeasureCode: 'ppm'
};
